/*
 * View for inspecting and changing campaigns
 */

define(["marionette", "./template/campaignsTemplate.html"], function (
  Marionette,
  CampaignsTemplate,
) {
  const CampaignsView = {};

  CampaignsView.campaignsView = Marionette.Layout.extend({
    template: CampaignsTemplate,
    triggers: {
      "click #addCampaign": "add:campaign",
    },
    regions: {
      campaignList: "#campaignList",
      campaign: "#campaign",
    },
  });

  return CampaignsView;
});
